import React from 'react';
import { Button, ButtonGroup } from 'reactstrap';

function SelectionTabs({ setCurrentStat, currentStat }) {

  return (
    <ButtonGroup style={{
      marginTop: '-15px',
      marginLeft: 12,
    }} className='d-block mr-3 mb-2 mb-sm-0'>
      <Button
        outline
        onClick={() => setCurrentStat(1)}
        active={currentStat === 1}
      >
        LeaderBoard
      </Button>
      <Button
        outline
        onClick={() => setCurrentStat(2)}
        active={currentStat === 2}
      >
        Top Users With Star
      </Button>
    </ButtonGroup>
  );
}

export default SelectionTabs;